import { useEffect } from "react";

/**
 * add ESCAPE key listener
 * @param callback function called on user press ESC key
 */

export const useEsc = (callback: () => void) => {
  useEffect(() => {
    const close = (ev: KeyboardEvent) => {
      if (ev.key === "Escape") {
        callback();
      }
    };
    window.addEventListener("keydown", close);
    return () => window.removeEventListener("keydown", close);
  }, [callback]);
};
